export default {
  odStatus: {
    0: '已取消',
    1: '待上传资料',
    2: '待填写申请表',
    3: '待支付',
    4: '待邮寄资料',
    5: '办理中',
    6: '已发货',
    7: '待评价',
    8: '已完成',
    9: '已删除',
    10: '待选择日期',
  },
  apStatus: {
    0: '已取消',
    1: '等待预审',
    2: '资料不完善',
    3: '等待送签',
    4: '使馆审核中',
    5: '出签成功',
    6: '拒签',
    7: '退款中',
    8: '退款成功',
    9: '等待预约',
    10: '待确认',
    11: '等待接收资料',
    12: '等待培训',
    13: '待前往使馆',
    14: '拒签(待提交证明)',
    15: '拒签(等待审核)',
    16: '拒签(审核不通过)',
    17: '资料不完善（待退款）',
    18: '预约成功',
  },
  maStatus: {
    0: '未知',
    1: '未婚',
    2: '已婚',
    3: '离异',
    4: '丧偶',
  },
  IDCardSpecialStatus: {
    1: '未满16周岁，尚未办理身份证',
    2: '身份证丢失',
  },
  application_status: {
    0: '预审已通过',
    1: '待填写',
    2: '待预审',
    3: '预审未通过',
  },
  elec_status: {
    0: '预审已通过',
    1: '待上传资料',
    2: '待预审',
    3: '预审未通过',
    4: '特别处理',
  },
  paper_status: {
    0: '预审已通过',
    1: '待邮寄',
    2: '待签收',
    3: '待预审',
    4: '预审未通过',
  },
  identity: {
    0: '在职人员',
    1: '自由职业者',
    2: '退休人员',
    3: '在校学生',
    4: '学龄前儿童',
  },
  rejectFileStatus: {
    0: '待上传',
    1: '等待审核',
    2: '审核不通过',
    3: '审核通过',
    4: '超时未提交',
  },
  rejectProductStatus: {
    0: '保障生效中',
    1: '保障成功',
    2: '保障结束',
    3: '保障已赔付',
  },
};



// WEBPACK FOOTER //
// ./src/libs/status.js